<template>
  <div class="menu__list">
    <div class="title" @click="handleTitle(item)">
      <div class="menu__item">
        {{ item.title }}
      </div>
    </div>
    <div class="sublist">
      <div
        v-for="sublist in item.children"
        :key="sublist.path"
        class="sublist__item"
      >
        <router-link
          :to="sublist.path"
          v-if="
            sublist.userType === 'all' ? true : sublist.userType === userType
          "
          @click.native.prevent="handleSublist(sublist.path)"
          >{{ sublist.name }}</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item", "userType"],
  data() {
    return {};
  },
  methods: {
    handleTitle(menu) {
      if (this.$route.path !== menu.path) {
        this.$router.push(menu.path);
      } else {
        this.$emit("menu-click");
      }
    },
    handleSublist(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      } else {
        this.$emit("menu-click");
      }
    },
  },
};
</script>
<style scoped>
.menu__list {
  margin-top: 24px;
}
.title {
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  margin-bottom: 12px;
}
.menu__item {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--gray-700);
}
.sublist {
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--gray-600);
  margin-bottom: 22px;
}
.sublist__item {
  margin-bottom: 10px;
}
</style>
